import mixpanel from 'mixpanel-browser';
import DevsiteCookies, { removeCookie } from '../DevsiteCookies';
import { destroyAnonymousDeviceId, getOrCreateAnonymousDeviceId } from './anonymousDeviceId';

/**
 * Site-wide Mixpanel opt-out. Uses the unprefixed `disableUserMetrics` key so the
 * existing hidden localStorage mechanism continues to work.
 */
export const DISABLE_USER_METRICS_KEY = 'disableUserMetrics';

/**
 * Returns whether user metrics are allowed. Missing or empty storage values keep
 * tracking on; any non-empty value opts out. Storage errors default to enabled.
 */
export const userMetricsEnabled = (): boolean => {
  try {
    return !localStorage.getItem(DISABLE_USER_METRICS_KEY);
  } catch {
    return true;
  }
};

/**
 * Persists Mixpanel opt-out. Logout must not clear this key.
 */
export const disableUserMetrics = (): void => {
  try {
    localStorage.setItem(DISABLE_USER_METRICS_KEY, 'true');
    destroyAnonymousDeviceId();
    removeCookie(DevsiteCookies.ANALYTICS_ID);
    mixpanel.opt_out_tracking();
  } catch {
    // storage unavailable (e.g. blocked browsers)
  }
};

/**
 * Removes the opt-out so Mixpanel may run again in this session.
 */
export const enableUserMetrics = (): void => {
  try {
    localStorage.removeItem(DISABLE_USER_METRICS_KEY);
    getOrCreateAnonymousDeviceId();
    mixpanel.opt_in_tracking();
  } catch {
    // storage unavailable (e.g. blocked browsers)
  }
};
